import { Text } from "@mantine/core";
import clsx from "clsx";
import InfoItem from "components/InfoItem";
import IconLoadingAddress from "icons/shipment/loading-address.svg";
import IconUnloadingAddress from "icons/shipment/unloading-address.svg";
import { useTranslation } from "react-i18next";

interface ChatContextAddressItemProps {
  type: "receiver" | "sender";
  value?: string | null;
  name?: string | null;
}

const iconByType = {
  receiver: <IconUnloadingAddress className="w-6 h-6 text-red-dark" />,
  sender: <IconLoadingAddress className="w-6 h-6 text-green" />,
};

const ChatContextAddressItem: React.FC<ChatContextAddressItemProps> = ({
  type,
  value,
  name,
}) => {
  const { t } = useTranslation("tripActivity");

  return (
    <InfoItem
      gap={8}
      align="flex-start"
      visible={!!(value || name)}
      icon={iconByType[type]}
      label={
        <>
          {value && (
            <Text fz={14} className="wrap-break-word">
              {value}
            </Text>
          )}
          {name && (
            <Text
              fz={12}
              className={clsx("wrap-break-word text-gray-light", {
                "pt-1": !value,
              })}
            >
              {t(type)}: {name}
            </Text>
          )}
        </>
      }
    />
  );
};

export default ChatContextAddressItem;
